import { Component, OnInit, ElementRef } from '@angular/core';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Location } from '@angular/common';
import { ViewChild } from '@angular/core';
import { DataService } from "../../bpg-common/services/data.services";

@Component({
  selector: 'app-naac-folder',
  templateUrl: './naac-folder.component.html',
  styleUrls: ['./naac-folder.component.css']
})
export class NaacFolderComponent implements OnInit {
  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: any;
  loginData: any;
  loginUserId: string;
  chapterId: number;
  createdBy: any;
  createdDateTime: any;
  modifiedBy: any;
  modifiedDateTime: any;
  userId: any;
  numberOfElements: number;
  currentPage: number = 0;
  currentNumberOfElements: number = 10;
  totalPages: number = 0;
  tableShow: any;
  limit: number = 10;
  currentShowingElements: number = 10;
  searchKey: any;
  searchTerm: any;
  landingData: any;
  tableresp: boolean;
  loginDetails: any;
  loginDataDetails: any;
  page: number = 0;
  documentsFolderList: any = null;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  errorMsgUploadSave: boolean = false;
  userAndRoleIdDTO: any;
  filterType: any;
  folderName: any;
  folderOrder: any;
  folderId: any = null;
  editAndSave: boolean = false;
  alertUpdateSuccess: boolean = false;
  errorMessage: any;
  firstEdit: boolean = false;
  naacId: any = localStorage.getItem('naacId');


  constructor(private userService: SelfService,
    private adminService: BpgAdminServices,
    private spinner: Ng4LoadingSpinnerService,
    
    private router: Router,
    private environment: EnvironmentConfiguration,
    private location: Location,
    private data: DataService) { }

  ngOnInit() {
    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') == "true") {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/log-out']);
      localStorage.setItem("logOutFlag", "true");

    }
    this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));
    localStorage.removeItem('searchedEventsCaledarItems');
    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));


    // if (this.loginDetails == null) {
    //   this.router.navigate(['/login']);
    // }
    this.spinner.show();
    sessionStorage.removeItem("MembershipData");
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.userId = this.loginData.userId;
    this.createdBy = this.loginData.userId;
    this.modifiedBy = this.loginData.userId;
    this.getDocumentsFolderList();

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);

  }

  /** get Folder list
   * @class AdditionalResourceComponent
   * @method getDocumentsFolderList
   */
  public getDocumentsFolderList() {
    this.landingData = {
      "filter": {},
      "moduleId": 0,
      "page": this.page,
      "presentRole": "",
      "searchTerm": "",
      "size": 50,
      "sortDirection": "ASC",
      "sortProperty": "folder_order",
      "uid": ""
    }

    this.userService.getNaacDocumentsFolder(this.landingData).subscribe(data => {
      var documentsFolderList = data.content;
      this.documentsFolderList = [];
      for (var i = 0; i < documentsFolderList.length; i++) {
        if (documentsFolderList[i].naacId == this.naacId) {
          this.documentsFolderList.push(documentsFolderList[i]);
        }
      }

      this.numberOfElements = this.documentsFolderList.length;
      this.spinner.hide();
      if (this.documentsFolderList.length == 0) {
        this.noDataFound = true;
        this.tableShow = false;
      } else {
        this.noDataFound = false;
        this.tableShow = true;
      }
    });
  }

  /** to submit resource
     * @class Additional Resource Component
     * @method onManageFolderSubmit
     */
  public onManageFolderSubmit() {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;

    this.method = "addDocumentsFolder";
    this.param = '';
    if (this.editAndSave) {
      this.msg1 = " Are you sure you want to update ? ";
    } else {
      this.msg1 = " Are you sure you want to save ? ";
    }

  }


  /** to add new folder
    * @class Additional Resource Component
    * @method addFolder
    */
  public addDocumentsFolder() {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.alertUpdateSuccess = false;
    this.modifiedDateTime = new Date();
    let folderData = null;
    this.spinner.show();
    if (this.folderId != null) {
      folderData = {
        "folderId": this.folderId,
        "folderName": this.folderName,
        "id": this.userId,
        "folderOrder": this.folderOrder,
        "naacId": this.naacId
      }
    }
    else {
      folderData = {
        "folderId": 0,
        "folderName": this.folderName,
        "id": this.userId,
        "folderOrder": this.folderOrder,
        "naacId": this.naacId
      }
    }
    this.userService.addNaacDocumentsFolder(folderData).subscribe(data => {
      if (data.message) {
        this.spinner.hide();
        this.errorMsg = data.message;
        this.alertFailure = true;
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        return;
      }
      if (this.editAndSave) {
        this.alertUpdateSuccess = true;
      } else {
        this.alertSuccess = true;
      }
      this.alertFailure = false;
      this.getDocumentsFolderList();
      this.spinner.hide();
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
    }, err => {
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.alertFailure = true;
        this.alertSuccess = false;
      }
    })

  }


  /** For filtering data by current page
   * @class Additional Resource Component
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getDocumentsFolderList();
  }


  public updateDocument(data, i) {
    if (this.firstEdit == false) {
      this.firstEdit = true;
      this.editFolder(data);
    } else {
      document.getElementById('edit' + i).setAttribute('data-toggle', 'modal');
      document.getElementById('edit' + i).setAttribute('data-target', '#myModal');
      this.method = "editFolder";
      this.param = data;
      this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }


  /** to Delete folder
* @class Additional Resource Component
* @method deletefolder
*/
  deleteNaacDocumentsFolder(folderId) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.alertUpdateSuccess = false;
    this.spinner.show();
    this.userService.deleteNaacDocumentsFolder(folderId).subscribe(data => {
      this.spinner.hide();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      this.alertSuccess = false;
      this.errorMsgUploadSave = false;
      if (this.documentsFolderList.length == 1 && this.numberOfElements > 10) {
        this.currentPage = 0;
        this.page = 0;
        this.currentShowingElements = 10
      }
      this.getDocumentsFolderList();
    });
  }


  /** confirmation to delete folder
* @class Additional Resource Component
* @method deleteFolderConfirmation
*/
  public deleteFolderConfirmation(id) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.method = "deleteNaacDocumentsFolder";
    this.param = id;
    this.msg1 = "  Deleting folder would delete all the files in it, Are you sure you want to delete ? ";
  }


  public getDocumentsFolderListForSearch() {
    this.page = 0;
    this.currentPage = 1;
    this.getDocumentsFolderList();

  }

  editFolder(data) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.editAndSave = true;
    this.folderId = data.folderId;
    this.folderName = data.folderName;
    this.chapterId = data.chapterId;
    this.folderOrder = data.folderOrder;
    this.createdDateTime = data.createdDateTime;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }


  /** to select cancel
    * @class CreateAndEditExpenseClaimComponent
    * @method cancelClick
    */
  cancelClick() {
    this.method = "navigate";
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
    this.param = "";
  }

  navigate() {
    this.data.folderSections(true);
    this.location.back();
    window.scrollTo(0, 0);
  }
}

